let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gcXcg"), load("c6MKV"), load("f0OaY")]).then(() => parcelRequire('bkgW7'));